import React from 'react';

const AuthorDetails = ({ authorName }) => {
  return (
    <>
      <div className="author-container flex-container align-center margin-top--md margin-bottom--lg">
        {/* <div className="logo-container">
              <img src={logo} alt="logo" />
            </div> */}
        <p className="author-name">{authorName}.</p>
      </div>
      <style jsx>
        {`
          .author-container {
            flex-wrap: wrap;
          }
          .author-name {
            margin-right: 10px;
          }
          .logo-container img {
            height: 50px;
            width: auto;
            max-width: 100px;
            object-fit: contain;
            margin-right: 10px;
          }
        `}
      </style>
    </>
  );
};

export default AuthorDetails;
